export default __webpack_public_path__ + "media/images/logo/media/chiba_tv-3620bab6006c9dce9cecd23488704b29.png";